class PrimaryNav {

  constructor(){
    this.navigation       = document.querySelector('#js--primary-nav');
    this.navigationToggle = document.querySelector('#js--primary-header-toggle');
    this._init();
  }

  _init(){

    document.addEventListener('DOMContentLoaded', (event) => {
      this.navigationToggle.addEventListener('click', 
        this._updateNav.bind(this),
        false
      );

      var larX = jQuery(window).width();
      jQuery(window).resize(function() {
        larX = jQuery(this).width();
      });      

      jQuery('#js--primary-nav > li > a').on('click',function(){
        jQuery(this).next().addClass('actif');

        if((larX >= 1065 )&&(jQuery(this).parent().find( 'ul' ).prop('tagName')) === 'UL'){
          return false;
        }
      });

      jQuery('.primary-nav__close').on('click',function(){
        jQuery(this).parent().removeClass('actif');
      });

    });
  }

  _updateNav(){
    this._toggleState(this.navigation, 'open', 'closed');
    this._toggleState(this.navigationToggle, 'open', 'closed');
  }

  _toggleState(elem, one, two){
    let newState = elem.getAttribute('data-state') === one ? two : one;
    elem.setAttribute('data-state', newState);
  }

}

export let primaryNav = new PrimaryNav();
